import { memo } from "react";
import PropTypes from "prop-types";
import { Box, Grid, Paper, Typography } from "@mui/material";

import { UploadNameTag } from "pages/BulkUpload/BulkUploadStatusHistory/components";
import { formatDateTime, formatCount } from "utils";

import { SUMMARY_TILES } from "../constants";

const RequestMetaItem = ({ label, children }) => (
  <Grid item xs={6} sm={2.4}>
    <Typography variant="caption" color="text.secondary">
      {label}
    </Typography>
    <Box mt={0.5}>{children}</Box>
  </Grid>
);

RequestMetaItem.propTypes = {
  label: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
};

const SummaryTile = ({ label, value, color }) => (
  <Paper
    variant="outlined"
    sx={{
      flex: 1,
      minWidth: 140,
      p: 2,
      borderColor: "grey.300",
      borderTop: "3px solid",
      borderTopColor: color,
    }}
  >
    <Typography variant="h5" fontWeight={700} sx={{ color }}>
      {value}
    </Typography>
    <Typography variant="caption" color="text.secondary">
      {label}
    </Typography>
  </Paper>
);

SummaryTile.propTypes = {
  label: PropTypes.string.isRequired,
  value: PropTypes.string.isRequired,
  color: PropTypes.string.isRequired,
};

const RequestSummaryHeader = ({ request }) => {
  return (
    <Box>
      <Paper variant="outlined" sx={{ p: 3, mb: 2, borderColor: "grey.300" }}>
        <Grid container spacing={2}>
          <RequestMetaItem label="Request ID">
            <Typography variant="body2" fontWeight={700}>
              {request.requestId}
            </Typography>
          </RequestMetaItem>
          <RequestMetaItem label="Upload Name">
            <UploadNameTag uploadName={request.uploadName} />
          </RequestMetaItem>
          <RequestMetaItem label="File">
            <Typography variant="body2" fontWeight={600}>
              {request.fileName}
            </Typography>
          </RequestMetaItem>
          <RequestMetaItem label="Uploaded By">
            <Typography variant="body2" fontWeight={600}>
              {request.uploadedBy}
            </Typography>
          </RequestMetaItem>
          <RequestMetaItem label="Uploaded At">
            <Typography variant="body2" fontWeight={600}>
              {formatDateTime(request.uploadedAt)}
            </Typography>
          </RequestMetaItem>
        </Grid>
      </Paper>

      <Box display="flex" gap={2} flexWrap="wrap" mb={2}>
        {SUMMARY_TILES.map(({ key, label, color }) => {
          return (
            <SummaryTile
              key={key}
              label={label}
              value={formatCount(request?.[key])}
              color={color}
            />
          );
        })}
      </Box>
    </Box>
  );
};

RequestSummaryHeader.propTypes = {
  request: PropTypes.shape({
    requestId: PropTypes.string.isRequired,
    uploadName: PropTypes.string.isRequired,
    fileName: PropTypes.string.isRequired,
    uploadedBy: PropTypes.string.isRequired,
    uploadedAt: PropTypes.string,
  }).isRequired,
};

export default memo(RequestSummaryHeader);
